export default "__VITE_ASSET__BRxT_94J__"